import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Suspense as _Suspense, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute bottom-0 p-4 bg-white"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Ingelogd op het verkeerde apparaat? Klik hieronder om uit te loggen.", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Uitloggen")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AdminCockpit = _resolveComponent("AdminCockpit")!
  const _component_AlertViewer = _resolveComponent("AlertViewer")!
  const _component_DialogViewer = _resolveComponent("DialogViewer")!
  const _component_VOffline = _resolveComponent("VOffline")!
  const _component_ButtonRegular = _resolveComponent("ButtonRegular")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        (_ctx.user.role === _ctx.UserRoles.ADMININISTRATOR)
          ? (_openBlock(), _createBlock(_component_AdminCockpit, {
              key: 0,
              onMousemove: _ctx.onMouseMove
            }, {
              default: _withCtx(() => [
                _createVNode(_component_router_view, null, {
                  default: _withCtx(({Component}) => [
                    (_openBlock(), _createBlock(_KeepAlive, null, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                    ], 1024))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onMousemove"]))
          : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
      ]),
      _: 1
    })),
    _createVNode(_component_AlertViewer),
    _createVNode(_component_DialogViewer),
    _createVNode(_component_VOffline, { onDetectedCondition: _ctx.onNetworkChange }, null, 8, ["onDetectedCondition"]),
    (_ctx.displayLogoutPrompt)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_ButtonRegular, { onClick: _ctx.logout }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}